var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0104 21.9921L27.1964 12.8061C27.3795 12.6191 27.598 12.4704 27.839 12.3684C28.08 12.2664 28.3388 12.2133 28.6005 12.2119C28.8622 12.2106 29.1216 12.2612 29.3636 12.3607C29.6056 12.4603 29.8255 12.6068 30.0106 12.7918C30.1956 12.9769 30.3422 13.1968 30.4417 13.4388C30.5412 13.6809 30.5918 13.9402 30.5905 14.2019C30.5892 14.4636 30.536 14.7225 30.434 14.9635C30.332 15.2045 30.1833 15.4229 29.9964 15.6061L22.1964 23.4061L29.9964 31.2061C30.3615 31.5786 30.5648 32.0803 30.5622 32.6019C30.5596 33.1236 30.3512 33.6231 29.9823 33.992C29.6134 34.3609 29.1139 34.5693 28.5922 34.5719C28.0706 34.5745 27.569 34.3712 27.1964 34.0061L18.0104 24.8221C17.6354 24.447 17.4248 23.9384 17.4248 23.4081C17.4248 22.8777 17.6354 22.3691 18.0104 21.9941V21.9921Z",
    fill: "#6B6E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftLarge);
export default __webpack_public_path__ + "static/media/chevron-left-large.60af35ce4b8788ffc25922f701c1afcd.svg";
export { ForwardRef as ReactComponent };